export default function ({ ...props }) {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width="66" height="34" viewBox="0 0 66 34" fill="none">
            <rect x="0.5" y="0.5" width="65" height="33" rx="16.5" stroke="white" />
            <circle cx="49" cy="17.002" r="14" fill="#33FF00" />
        </svg>
    );
}
